import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum Week {
  Mon = 1,
  Tues = 2,
  Wed = 3,
  Thurs = 4,
  Fri = 5,
  Sat = 6,
  Sun = 7,
}
EnumDescriptions.setDescriptions(Week, [
  i18n.t('enums.week.mon'),
  i18n.t('enums.week.tues'),
  i18n.t('enums.week.wed'),
  i18n.t('enums.week.thurs'),
  i18n.t('enums.week.fri'),
  i18n.t('enums.week.sat'),
  i18n.t('enums.week.sun'),
]);
